import { clsx, useRender, userModeProps, } from '@a-type/ui';
import { colors, } from '@long-game/common';
import { useGameSuite } from '@long-game/game-client';
// stabilized objects
const byPalette = Object.fromEntries(Object.entries(colors).map(([name, palette]) => [
    name,
    {
        palette,
        className: '@mode-user',
        style: {
            [userModeProps.$userColorHue]: palette.okHue,
            [userModeProps.$userColorSaturation]: palette.okSaturation,
        },
    },
]));
export function usePlayerThemed(playerId) {
    const suite = useGameSuite();
    const player = playerId ? suite.getPlayer(playerId) : null;
    if (!player)
        return {
            className: '@mode-user',
            style: {
                [userModeProps.$userColorHue]: 0,
                [userModeProps.$userColorSaturation]: 0,
            },
            palette: colors.gray,
        };
    return byPalette[player.color];
}
export function PlayerThemed({ playerId, className, style, ...rest }) {
    const themed = usePlayerThemed(playerId);
    return useRender({
        defaultTagName: 'div',
        props: {
            className: clsx(themed.className, className),
            style: { ...themed.style, ...style },
            ...rest,
        },
    });
}
//# sourceMappingURL=usePlayerThemed.js.map